export type RcPendingConfirmation = {
  confirmToken: string;
  summary: string;
  toolName: string;
};

export type RcChatMessage = {
  id: string;
  role: "user" | "assistant" | "system";
  content: string;
  pendingConfirmations?: RcPendingConfirmation[];
};

export type RcPageContext = {
  pathname: string;
  rfqId?: number;
  emailId?: number;
  poId?: number;
  priceQuoteId?: number;
  /** Most recently opened RFQ detail (session). Used for "go back to last RFQ". */
  lastRfqId?: number;
  /** Line RC last opened / is editing on the current RFQ. */
  focusedHomeworkItemId?: number;
  role?: string;
};

export type RcChatRequest = {
  message?: string;
  conversationId?: string;
  pageContext: RcPageContext;
  confirmToken?: string;
  cancelConfirmToken?: string;
};

export type RcChatResponse = {
  reply: string;
  clientActions: import("./rcClientActions").RcClientAction[];
  pendingConfirmations: RcPendingConfirmation[];
  conversationId: string;
  invalidate?: string[];
};

let msgCounter = 0;
export function nextMessageId(): string {
  msgCounter += 1;
  return `rc-msg-${Date.now()}-${msgCounter}`;
}
